export default __webpack_public_path__ + "2bd533a3640bfe6c1df258544ed64f76.svg";